{% block ecocode_trustpilot_connect %}
        <sw-system-config
            ref="systemConfig"
            salesChannelSwitchable
            domain="EcocodeTrustpilot.config">
        </sw-system-config>
{% endblock %}
